import { render } from "./ConfirmUnNftInfoDialog.vue?vue&type=template&id=15e315a4&scoped=true"
import script from "./ConfirmUnNftInfoDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmUnNftInfoDialog.vue?vue&type=script&lang=js"

import "./ConfirmUnNftInfoDialog.vue?vue&type=style&index=0&id=15e315a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e315a4"]])

export default __exports__